export default __webpack_public_path__ + "static/media/handClick.a566bf6e.gif";